export default __webpack_public_path__ + "static/media/DSC_0570.7fdd2d2e.webp";